module.exports = __webpack_public_path__ + "static/media/campaigns-empty.14e222f0.svg";